import HelpCategories from './HelpCategories';
import HelpSearch from './HelpSearch';

export default function Help() {
    return (
        <div className="help">
            <HelpSearch />
            <div className="help__search">
                <HelpCategories />
            </div>
        </div>
    );
}
